import NotificationRecipient from "models/notification-recipient";
import {
  axiosInstance as Repository,
} from "../repository";

const RESOURCE = "/notification-recipients";

function getInstance(item) {
  const obj = new NotificationRecipient(item.organization_id);
  obj.notificationRecipientId = item.notification_recipient_id;
  obj.recipientType = item.recipient_type;
  obj.email = item.email;

  return obj;
}

function makeRequestJson(notificationRecipient) {
  let requestJosn = {};

  requestJosn = {
    organization_id: notificationRecipient.serviceAccountId,
    notification_recipient_id: notificationRecipient.notificationRecipientId,
    recipient_type: notificationRecipient.recipientType,
    email: notificationRecipient.email,
  };

  return requestJosn;
}

export default {
  async index(serviceAccountId) {
    const response = await Repository.get(`${RESOURCE}`, {
      params: {
        organization_id: serviceAccountId,
      },
    });
    const items = [];
    response.data.items.forEach((item) => {
      items.push(getInstance(item));
    });
    return items;
  },

  async get(serviceAccountId, notificationRecipientId) {
    const response = await Repository.get(`${RESOURCE}/${notificationRecipientId}`, {
      params: {
        organization_id: serviceAccountId,
      },
    });
    return NotificationRecipient.getInstance(response.data);
  },

  async store(notificationRecipient) {
    const requestParams = makeRequestJson(notificationRecipient);
    await Repository.post(`${RESOURCE}?organization_id=${notificationRecipient.serviceAccountId}`, requestParams);
  },

  async destroy(notificationRecipient) {
    await Repository.delete(`${RESOURCE}/${notificationRecipient.notificationRecipientId}`, {
      params: {
        organization_id: notificationRecipient.serviceAccountId,
      },
    });
  },

};
